// extracted by mini-css-extract-plugin
export default {"container":"Courses_container__Vkux+","search":"Courses_search__OOdbE","wrapper":"Courses_wrapper__8yhvi"};